import { Button } from "./ui/button";

export default function BookletResultFilter({ group, selected, onChange }) {
  const all = group.members.map(m => m.number);
  const total = all.length === selected.length;
  return <fieldset className="border border-primary/40 bg-primary/5 p-4 mb-5" aria-label="Cadernos nos resultados">
    <legend className="px-2 font-semibold">Resultados: {total ? "Total" : `caderno${selected.length > 1 ? "s" : ""} ${selected.join(" + ")}`}</legend>
    <div className="flex flex-wrap items-center gap-4">
      <Button variant={total ? "default" : "outline"} onClick={() => onChange(all)}>Total</Button>
      {group.members.map(m => <label key={m.exam_id} className="flex items-center gap-2">
        <input type="checkbox" checked={selected.includes(m.number)} disabled={selected.length === 1 && selected[0] === m.number}
          onChange={e => onChange((e.target.checked ? [...selected, m.number] : selected.filter(n => n !== m.number)).sort((a, b) => a - b))} />
        Tipo {m.number}
        <button type="button" className="text-xs underline text-primary" aria-label={`Ver somente caderno ${m.number}`} onClick={() => onChange([m.number])}>somente</button>
      </label>)}
    </div>
    <p className="text-sm text-muted-foreground mt-3">Selecione um ou vários tipos. Totais, resultados, gráficos e exportação seguem esta seleção. A edição e a revisão continuam no caderno aberto.</p>
  </fieldset>;
}
